/**
 * The EyeCaptain wordmark in the right colours for the theme: light lettering
 * on dark, dark lettering on light.
 *
 * Both images are in the markup and CSS picks one (`light:` variant, from the
 * class index.html puts on <html> before the first paint), so a prerendered
 * page shows the right logo at once and hydration has nothing to correct.
 * The light one is lazy: a dark visitor never downloads it.
 */
import type { ImgHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import onDark from "@/assets/eyecaptain-logo-dark.webp";
import onLight from "@/assets/eyecaptain-logo-onlight.webp";

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src">;

export function EyeCaptainLogo({ className, alt = "EyeCaptain", loading, ...rest }: Props) {
  return (
    <>
      <img {...rest} src={onDark} alt={alt} loading={loading} className={cn(className, "light:hidden")} />
      <img {...rest} src={onLight} alt={alt} loading="lazy" fetchPriority="low" className={cn(className, "hidden light:block")} />
    </>
  );
}

export default EyeCaptainLogo;
